// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"57933d58","453":"6ea0d611","455":"2ccc4034"}[chunkId] + ".chunk.js";
};